<template>
  <b-row class="px-2 mt-3">
    <b-col lg="12" class="mb-3 mb-lg-0 d-flex">
      <iq-card class="fuel-card h-100 w-100">
        <div class="iq-card-body" style="padding: 15px 20px;">
          <div class="fms-card-header">
            <div>
              <h4>Flow Rate Trend</h4>
              <p class="text-muted">All flow rate over the last 24 hours.</p>
            </div>
            <span class="fms-tag fms-tag--outline">24H Window</span>
          </div>
          <b-row>
            <b-col lg="6" class=" px-2" v-for="meter in flowmeters" :key="meter.id">
              <flow-rate-chart
                :key="meter.id"
                :series="meter.series"
                :seriesKey="meter.seriesKey"
                :side="meter.side"
                :title="meter.title"
                :avgFlow="meter.avgFlow"
                :engineCons="meter.engineCons"
                :currentFlowrate="meter.current?.flowrate"
                :currentDensity="meter.current?.density"
                :currentTemp="meter.current?.temp"
            />
            </b-col>
          </b-row>
        </div>
      </iq-card>
    </b-col>
  </b-row>
</template>

<script>
import FlowRateChart from '../charts/FlowrateChart';

export default {
  name: 'FlowRateTrendCard',
  components: {
    FlowRateChart,
  },
  props: {
    currAssetSummary: {
      type: Object,
      required: true,
    },
    currAssetLastData: {
      type: Object,
      default: null,
    },
    deviceStatus: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    flowmeters() {
      const meters = [];
      const { fm, series } = this.currAssetSummary || {};
      const { flowmeterPositions } = this.deviceStatus || {};
      const lastFm = this.currAssetLastData?.fm || {};

      if (!fm || !flowmeterPositions || !series) return [];

      flowmeterPositions.forEach((pos) => { // 'PORT', 'STARBOARD', 'CENTER'
        const posData = fm[pos];
        if (!posData) return;

        if (posData.in) {
          meters.push({
            id: `${pos}_IN`,
            title: `${pos} In Flow Rate`,
            side: pos.toLowerCase(),
            series,
            seriesKey: `${pos}_IN`,
            avgFlow: posData.in.avgFuelFlow,
            engineCons: posData.in.engineCons,
            current: lastFm[`${pos}_IN`],
          });
        }
        if (posData.out) {
          meters.push({
            id: `${pos}_OUT`,
            title: `${pos} Out Flow Rate`,
            side: pos.toLowerCase(),
            series,
            seriesKey: `${pos}_OUT`,
            avgFlow: posData.out.avgFuelFlow,
            engineCons: posData.out.engineCons,
            current: lastFm[`${pos}_OUT`],
          });
        }
      });

      return meters;
    },
  },
};
</script>

<style scoped>
.fuel-section {
  margin-top: 12px;
  padding: 12px;
  border: 2px solid #E8ECF3;
  border-radius: 20px;
}
</style>
